import { render, staticRenderFns } from "./select-merchant.vue?vue&type=template&id=f53ffaba&scoped=true"
import script from "./select-merchant.vue?vue&type=script&lang=js"
export * from "./select-merchant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53ffaba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f53ffaba')) {
      api.createRecord('f53ffaba', component.options)
    } else {
      api.reload('f53ffaba', component.options)
    }
    module.hot.accept("./select-merchant.vue?vue&type=template&id=f53ffaba&scoped=true", function () {
      api.rerender('f53ffaba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/components/select-merchant.vue"
export default component.exports